import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from "reactstrap";
import { Layer } from "../../../../actions/Layers/constants";
import usePatchLayer from "../../../../hooks/usePatchLayer";
import { Button } from "../../../Helper/Button";

interface InvalidLayerModalProps {
    layer: Layer;
}

export function InvalidLayerModal({ layer }: InvalidLayerModalProps) {
    const patchLayer = usePatchLayer();
    const navigate = useNavigate();
    const [isInvalidModalOpen, toggleInvalidModal] = useState(false);

    const markInvalid = () => {
        if (layer) {
            patchLayer(layer, "active", false).then(() => {
                toggleInvalidModal(false);
                if (layer.parents.length > 0) {
                    const layer_id = layer.parents[0].id;
                    navigate(`/layer/${layer_id}`);
                } else navigate(`/layer`);
            });
        }
    };
    return (
        <>
            <Button color="danger" outline onClick={() => toggleInvalidModal(true)} icon={faTrash}>Delete</Button>

            <Modal isOpen={isInvalidModalOpen} className="modal-lg" toggle={() => toggleInvalidModal(!isInvalidModalOpen)}>
                <ModalHeader toggle={() => toggleInvalidModal(!isInvalidModalOpen)} >{`${layer.type} ${layer.label}`}</ModalHeader>

                <ModalBody>
                    <span>Please mark the {layer.type} as invalid if you think something went wrong.</span>
                </ModalBody>

                <ModalFooter>
                    <Button color="light" onClick={() => toggleInvalidModal(!isInvalidModalOpen)}>Cancel</Button>
                    <Button color="danger" onClick={markInvalid}>Mark Invalid</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}
